import { SvgIcon } from '@mui/material';
import React from 'react';
import { ReactComponent as Svg } from './medium.svg';

export const Medium = ()=>(
  <SvgIcon sx={{fillColor:'text.primary'}}><Svg/></SvgIcon>
)
